exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".affiliate-performance[data-v-4d11be42]{margin-bottom:32px}.card-affiliate-total[data-v-4d11be42]{margin-left:auto;color:#7d9eb5}.card-affiliate-name[data-v-4d11be42]{font-size:.875rem;font-weight:600}.card-affiliate-name span[data-v-4d11be42]{font-weight:400}", ""]);

// exports
